import appConfig from '../app-config';
import { apiCall } from './api';

const hostname = appConfig.api.plaidUrl;
const apiKey = appConfig.api.plaidKey;

export const apiPostLinkTokenCreate = async (clientUserId, consentedProducts, accessToken) => {
  let body = {
    client_user_id: clientUserId,
    access_token: accessToken,
  };

  if (consentedProducts) {
    body['additional_consented_products'] = consentedProducts
  }

  const results = await apiCall(hostname, 'link/token/create', 'POST', null, apiKey, null, JSON.stringify(body));

  return results.data;
};

export const apiPostItemPublicTokenExchange = async (publicToken) => {
  const body = {
    public_token: publicToken,
  };

  const results = await apiCall(hostname, 'item/public_token/exchange', 'POST', null, apiKey, null, JSON.stringify(body));

  return results.data;
};

export const apiPostItemGet = async (accessToken) => {
  const body = {
    access_token: accessToken,
  };

  const results = await apiCall(hostname, 'item/get', 'POST', null, apiKey, null, JSON.stringify(body));

  return results.data;
};

export const apiPostInstitutionsGetById = async (institutionId) => {
  const body = {
    institution_id: institutionId,
  };

  const results = await apiCall(hostname, 'institutions/get_by_id', 'POST', null, apiKey, null, JSON.stringify(body));

  return results.data;
};
